import React from 'react';
import { cn } from "@/lib/utils";

const levelClassMap: Record<string, string> = {
  "body-sm": "text-xs",
  "body-xs": "text-[0.6875rem]",
  "body-md": "text-sm",
  "body-lg": "text-base",
};

interface TextHighlighterProps {
  text?: string;
  searchTerm?: string | null;
  level?: "body-sm" | "body-xs" | "body-md" | "body-lg";
  className?: string;
}

const TextHighlighter: React.FC<TextHighlighterProps> = ({
  text = "",
  searchTerm = null,
  level = "body-sm",
  className,
}) => {
  const levelClass = levelClassMap[level] ?? "text-xs";

  if (!text)
    return null;

  if (!searchTerm || searchTerm.trim() === '')
    return <span className={cn(levelClass, className)}>{text}</span>;

  try {
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedSearchTerm})`, 'gi'));

    return (
      <span className={cn(levelClass, className)}>
        {parts.map((part, index) =>
          part.toLowerCase() === searchTerm.toLowerCase() ? (
            <mark key={index}>{part}</mark>
          ) : (
            <React.Fragment key={index}>{part}</React.Fragment>
          )
        )}
      </span>
    );
  } catch (error) {
    console.error("Error in text highlighting:", error);
    return <span className={cn(levelClass, className)}>{text}</span>;
  }
};

export default TextHighlighter;
